import Error500 from './Error500.component'

export default Error500
